






import Vue from 'vue';
import {Component, Inject} from 'vue-property-decorator';

@Component
export default class TabsBody extends Vue {
  @Inject() eventBus!: Vue;

}
